<cc-progress-bar [isLoading]="isLoading$ | async"></cc-progress-bar>
<spread-chart [timeFrame]="'M_3'" [data]="data$ | async" [isWidget]="true">
</spread-chart>
